<template>
    <div class="shop-detail">
        <el-row >
            <el-col :lg="10" :offset="2">
                店櫃代碼: {{this.shopDetail.shop_id}}
            </el-col>
            <el-col :lg="10" :offset="2">
                店櫃名稱: {{this.shopDetail.name}}
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">
                品牌: {{this.brand}}
            </el-col>
            <el-col :lg="10" :offset="2">
                 平板設備ID : 
                <ul v-for="device in this.shopDetail.device_id">
                    <li >
                     {{device.device_id}}
                    </li>
                </ul>
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">
                店櫃電話: {{this.shopDetail.tel}}
            </el-col>
            <el-col :lg="10" :offset="2">
                店櫃傳真: {{this.shopDetail.fax}}
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">
                區域: {{this.shopDetail.area_note}}
            </el-col>
            <el-col :lg="10" :offset="2">
                地址: {{this.shopDetail.city}}{{this.shopDetail.area}}{{this.shopDetail.address}}
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">
                簡介: {{this.shopDetail.note}}
            </el-col>
            <el-col :lg="12"></el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">
                美容師: 
                <ul v-for="item in this.beauticians">
                    <li >
                        {{item.name}}
                    </li>
                </ul>
            </el-col>
            <el-col :lg="10" :offset="2">
                業務:
                <ul>
                    <li v-for="item in this.sale">
                        {{item.name}}
                    </li>
                </ul>
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="12">
                <el-button type="primary" @click="editTabs">編輯</el-button>
                <el-button type="default" @click="back">返回</el-button>
            </el-col>
            <el-col :lg="12"></el-col>
        </el-row>
        
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
    export default {
        name: 'Detail',
        props: {
            shopKey: String
        },
        data() {
            return {
                shopDetail: [],
                beauticians: [],
                brand: '',
                sale: [],
            }
        },
        computed: mapGetters(["getShopDetail", "beauticiansItems", "salesItems"]),
        methods: {
            ...mapActions(["fetchShopDetail", "updateShop"]),
            fetch: function () {
                const data = {
                    _key: this.shopKey
                }
                this.$store.dispatch('fetchShopDetail', data)
                .then(() => {
                    this.shopDetail = this.getShopDetail
                    if (this.shopDetail.brand_id == 1) {
                        this.brand = "N牌"
                    }else {
                        this.brand = "S牌"
                    }
                    this.beauticians = this.beauticiansItems
                    this.sale = this.salesItems
                   
                }).catch((err) => {
                    console.log(err);
                });
            },
        
            back: function(){
                this.$emit('back')
            },
            editTabs: function () {
                this.$emit('editTabs', this.shopKey)
            }
        },
        created() {
            this.fetch()
        },
    }
</script>

<style lang="scss" scoped>
    body {
         background: rgb(181, 202, 160);
    }
    .shop-detail {
      
       
              font-weight: bold;
         font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
    }
    .el-row {
        margin: 2%;
    }
</style>